// extracted by mini-css-extract-plugin
module.exports = {"content":"support-modal_content__UmqZI"};